import { ServerCrash } from 'lucide-react'

import { ErrorState } from '@/components/ui/ErrorState'
import { Container } from '@/components/ui/Container'
import { getLocalizedPath } from '@/content/i18n'
import { siteContent } from '@/content/siteContent'
import { useDirection } from '@/hooks/useDirection'
import { useLocale } from '@/hooks/useLocale'
import { getLocalizedValue } from '@/lib/utils'

export function ServerErrorPage() {
  const locale = useLocale()
  useDirection(locale)

  return (
    <div className="min-h-screen bg-page-radial py-24">
      <Container className="flex justify-center">
        <ErrorState
          icon={<ServerCrash className="h-6 w-6" />}
          title={getLocalizedValue(siteContent.errors.server.title, locale)}
          description={getLocalizedValue(siteContent.errors.server.description, locale)}
          actions={[
            { label: locale === 'ar' ? 'العودة للرئيسية' : 'Return home', to: getLocalizedPath(locale) },
            { label: getLocalizedValue(siteContent.shared.contactUs, locale), to: getLocalizedPath(locale, 'contact'), variant: 'ghost' },
          ]}
        />
      </Container>
    </div>
  )
}
